import React from 'react'
import { Modal, Row, Typography, Button } from 'antd'
import { DownloadOutlined } from '@ant-design/icons'
import PropTypes from 'prop-types'
import ReactJson from 'react-json-view'
import fileDownload from 'js-file-download'

const jsonShouldCollpase = field => {
  if (!field.name) return false

  if (
    (field?.type === 'array' && field?.src?.length >= 5) ||
    (field?.type === 'object' && Object.keys(field?.src)?.length >= 5)
  ) {
    return true
  }
  return false
}

const JsonViewModal = ({ data, title, isModalOpen, closeModal }) => (
  <Modal
    width={1000}
    visible={isModalOpen}
    title={
      <Row>
        <Typography.Text>{title}</Typography.Text>
        <Button
          size="small"
          style={{ marginLeft: '25px' }}
          icon={<DownloadOutlined />}
          onClick={() =>
            fileDownload(JSON.stringify(data, null, 2), `${title}.json`)
          }
        />
      </Row>
    }
    onCancel={closeModal}
    footer={null}
  >
    <ReactJson
      src={data}
      name={false}
      enableClipboard={false}
      displayDataTypes={false}
      shouldCollapse={jsonShouldCollpase}
    />
  </Modal>
)

JsonViewModal.propTypes = {
  data: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  isModalOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
}

export default JsonViewModal
